import React, { useState } from 'react';
import { api } from '../../api';
import { Plus, Trash2, Save, X, Pencil, Star } from 'lucide-react';

const empty = { name: '', rating: 5, dateFr: '', dateEn: '', textFr: '', textEn: '', order: 0 };

const ReviewsAdmin = ({ content, refresh }) => {
  const [editing, setEditing] = useState(null);
  const [form, setForm] = useState(empty);

  const startNew = () => { setForm({ ...empty, order: (content.reviews?.length || 0) }); setEditing('new'); };
  const startEdit = (r) => { setForm(r); setEditing(r.id); };
  const cancel = () => { setEditing(null); setForm(empty); };

  const save = async () => {
    if (editing === 'new') await api.post('/admin/reviews', form);
    else await api.put(`/admin/reviews/${editing}`, form);
    await refresh();
    cancel();
  };

  const del = async (id) => {
    if (!window.confirm('Supprimer cet avis ?')) return;
    await api.delete(`/admin/reviews/${id}`);
    await refresh();
  };

  return (
    <div>
      <div className="flex items-center justify-between mb-8">
        <div>
          <h2 className="h-display text-[32px]">Avis clients</h2>
          <p className="text-[13px] text-[#8A8275] mt-1">Gérez les témoignages affichés sur la page d’accueil.</p>
        </div>
        <button onClick={startNew} className="btn-primary"><Plus size={14} /> Ajouter</button>
      </div>

      {editing && (
        <div className="bg-[#FAF8F4] border border-[#957340] p-6 mb-8">
          <div className="flex items-center justify-between mb-5">
            <div className="text-[11px] tracking-[0.32em] uppercase text-[#957340]">{editing === 'new' ? 'Nouvel avis' : 'Modifier'}</div>
            <button onClick={cancel}><X size={16} /></button>
          </div>
          <div className="grid md:grid-cols-2 gap-5">
            <Inp label="Nom du client" value={form.name} onChange={(v) => setForm({ ...form, name: v })} />
            <div>
              <span className="text-[10px] tracking-[0.28em] uppercase text-[#8A8275]">Note</span>
              <div className="mt-2 flex gap-1">
                {[1,2,3,4,5].map((n) => (
                  <button key={n} type="button" onClick={() => setForm({ ...form, rating: n })}>
                    <Star size={22} className={n <= form.rating ? 'fill-[#B8945B] text-[#B8945B]' : 'text-[#E8E2D5]'} />
                  </button>
                ))}
              </div>
            </div>
            <Inp label="Date (FR) ex: Il y a 2 semaines" value={form.dateFr} onChange={(v) => setForm({ ...form, dateFr: v })} />
            <Inp label="Date (EN) ex: 2 weeks ago" value={form.dateEn} onChange={(v) => setForm({ ...form, dateEn: v })} />
            <Area label="Témoignage (FR)" value={form.textFr} onChange={(v) => setForm({ ...form, textFr: v })} />
            <Area label="Témoignage (EN)" value={form.textEn} onChange={(v) => setForm({ ...form, textEn: v })} />
            <Inp label="Ordre" type="number" value={form.order} onChange={(v) => setForm({ ...form, order: parseInt(v) || 0 })} />
          </div>
          <div className="mt-6 flex gap-3">
            <button onClick={save} className="btn-primary"><Save size={14} /> Enregistrer</button>
            <button onClick={cancel} className="btn-ghost">Annuler</button>
          </div>
        </div>
      )}

      <div className="space-y-4">
        {(content.reviews || []).map((r) => (
          <div key={r.id} className="bg-white border border-[#E8E2D5] p-5">
            <div className="flex items-start justify-between">
              <div className="flex-1">
                <div className="flex items-center gap-3">
                  <span className="font-medium">{r.name}</span>
                  <span className="flex gap-0.5">{[...Array(r.rating)].map((_, i) => <Star key={`s-${r.id}-${i}`} size={12} className="fill-[#B8945B] text-[#B8945B]" />)}</span>
                  <span className="text-[10px] tracking-[0.28em] uppercase text-[#8A8275]">{r.dateFr}</span>
                </div>
                <p className="serif text-[15px] mt-2 text-[#3A3A3A] leading-relaxed">{r.textFr}</p>
                <p className="text-[12px] mt-1 text-[#8A8275] italic">{r.textEn}</p>
              </div>
              <div className="flex gap-1 shrink-0 ml-4">
                <button onClick={() => startEdit(r)} className="p-2 hover:text-[#957340]"><Pencil size={14} /></button>
                <button onClick={() => del(r.id)} className="p-2 hover:text-red-600"><Trash2 size={14} /></button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

const Inp = ({ label, value, onChange, type = 'text' }) => (
  <label className="block">
    <span className="text-[10px] tracking-[0.28em] uppercase text-[#8A8275]">{label}</span>
    <input type={type} value={value ?? ''} onChange={(e) => onChange(e.target.value)} className="mt-2 w-full bg-white border border-[#E8E2D5] focus:border-[#957340] outline-none p-3 text-[14px]" />
  </label>
);
const Area = ({ label, value, onChange }) => (
  <label className="block md:col-span-2">
    <span className="text-[10px] tracking-[0.28em] uppercase text-[#8A8275]">{label}</span>
    <textarea rows={3} value={value ?? ''} onChange={(e) => onChange(e.target.value)} className="mt-2 w-full bg-white border border-[#E8E2D5] focus:border-[#957340] outline-none p-3 text-[14px] resize-y" />
  </label>
);

export default ReviewsAdmin;
